import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

type TUseEditGoalFocusAreasMutation = {
  options?: any;
};

export const useEditGoalFocusAreasMutation = ({
  options,
}: TUseEditGoalFocusAreasMutation) => {
  const { goalId } = useParams();

  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({ focusAreaId, title }: { focusAreaId: string; title: string }) =>
      request({
        url: `/api/web/goals/${goalId}/breakdown/focus-areas/edit`,
        body: { focusAreaId, title },
      }),
    {
      ...options,
    }
  );
};
